<article class="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
  <p class="text-sm font-medium tracking-wide text-tan uppercase">Legals, rules &amp; privacy</p>
  <h1 class="mt-2 font-display text-4xl font-semibold text-ink italic sm:text-5xl">Privacy Policy</h1>
  <p class="mt-6 text-base leading-relaxed text-ink/80">
    Galopa collects information to operate our marketplace safely and comply with Australian
    regulations.
  </p>

  <div class="mt-12 space-y-10 text-ink">
    <section>
      <h2 class="font-display text-2xl font-semibold text-ink">1. Information We Collect</h2>
      <ul class="mt-4 list-disc space-y-2 pl-5 text-base leading-relaxed text-ink/80">
        <li>
          <span class="font-medium text-ink">Account Information:</span> Name, email, and basic
          profile details.
        </li>
        <li>
          <span class="font-medium text-ink">Identity Verification (KYC):</span> Processed via Stripe.
          We do not store your government ID or full financial details on our servers; these are
          handled directly by Stripe.
        </li>
        <li>
          <span class="font-medium text-ink">Communications:</span> Before a formal offer is accepted
          on a listing, messages between a buyer and seller are automatically screened by a third-party
          AI-based moderation service to enforce our strict policy against sharing Personal
          Identifiable Information (PII) or arranging an off-platform deal. Once an offer is accepted,
          messages on that listing are no longer screened this way.
        </li>
      </ul>
    </section>

    <section>
      <h2 class="font-display text-2xl font-semibold text-ink">2. How We Use Your Information</h2>
      <ul class="mt-4 list-disc space-y-2 pl-5 text-base leading-relaxed text-ink/80">
        <li>To facilitate transactions, hold and release inspection-window funds, and arbitrate disputes.</li>
        <li>To enforce our Terms of Use and prevent off-platform sales or fraud.</li>
        <li>To communicate important updates regarding your account or purchases.</li>
      </ul>
    </section>

    <section>
      <h2 class="font-display text-2xl font-semibold text-ink">3. Data Sharing</h2>
      <p class="mt-3 text-base leading-relaxed text-ink/80">
        We do not sell your personal data. We share data only in the following circumstances:
      </p>
      <ul class="mt-4 list-disc space-y-2 pl-5 text-base leading-relaxed text-ink/80">
        <li>
          <span class="font-medium text-ink">With Stripe:</span> For payment processing and KYC
          verification.
        </li>
        <li>
          <span class="font-medium text-ink">With our messaging moderation provider:</span> Pre-offer
          message content may be sent to a third-party AI moderation service solely to detect attempts
          to share contact details or move the transaction off-platform.
        </li>
        <li>
          <span class="font-medium text-ink">Between Users:</span> Only after a formal offer is
          accepted, we will share the necessary shipping details (name and address) so the seller can
          fulfill the order.
        </li>
        <li>
          <span class="font-medium text-ink">Legal Requirements:</span> If mandated by Australian law
          enforcement or dispute tribunals (e.g., NCAT/VCAT).
        </li>
      </ul>
    </section>

    <section>
      <h2 class="font-display text-2xl font-semibold text-ink">4. Security and Retention</h2>
      <p class="mt-3 text-base leading-relaxed text-ink/80">
        We use industry-standard encryption to protect your data. We retain your transaction history
        and dispute evidence for as long as your account is active, or as required by Australian tax
        and consumer laws, after which it is securely deleted.
      </p>
    </section>
  </div>

  <p class="mt-12 border-t border-line pt-8 text-sm text-ink/60">
    See also our
    <a routerLink="/terms" class="text-forest underline underline-offset-2 hover:text-forestdark"
      >Terms of Use</a
    >.
  </p>
</article>
